export default __webpack_public_path__ + "sort-up.png";